import React from "react";
import BaseMessage from "./BaseMessage";

export default function Error(props) {
    return <BaseMessage {...props} type={"error"} />
}